import { ThongkethegioService } from 'src/services/thongkethegio.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const THONGKETHEGIO_NEW_CARE_SUCCESS = 'THONGKETHEGIO:NEW_CARE_SUCCESS'
export const THONGKETHEGIO_LIST_SUCCESS = 'THONGKETHEGIO:FIND_ALL_SUCCESS'
export const THONGKETHEGIO_LIST_FAILD = 'THONGKETHEGIO:FIND_ALL_FAILD'
export const THONGKETHEGIO_COUNT_ASSIGN_SUCCESS = 'THONGKETHEGIO:COUNT_ASSIGN_SUCCESS'
export const THONGKETHEGIO_COUNT_ASSIGN_FAILD = 'THONGKETHEGIO:COUNT_ASSIGN_FAILD'

export const THONGKETHEGIO_CREATE_SUCCESS = 'THONGKETHEGIO:CREATE_SUCCESS'
export const THONGKETHEGIO_CREATE_FAILD = 'THONGKETHEGIO:CREATE_FAILD'

export const THONGKETHEGIO_IMPORT_SUCCESS = 'THONGKETHEGIO:IMPORT_SUCCESS'
export const THONGKETHEGIO_SAVE_SUCCESS = 'THONGKETHEGIO:SAVE_SUCCESS'
export const THONGKETHEGIO_SAVE_FAILD = 'THONGKETHEGIO:SAVE_SUCCESS'

export const THONGKETHEGIO_DEL_SUCCESS = 'THONGKETHEGIO:DEL_SUCCESS'
export const THONGKETHEGIO_DEL_FAILD = 'THONGKETHEGIO:DEL_FAILD'

export const THONGKETHEGIO_ONE_SUCCESS = 'THONGKETHEGIO:FIND_ONE_SUCCESS'
export const THONGKETHEGIO_ONE_FAILD = 'THONGKETHEGIO:FIND_ONE_FAILD'

export const THONGKETHEGIO_HISTORY_LIST_SUCCESS = 'THONGKETHEGIO:HISTORY_FIND_ALL_SUCCESS'
export const THONGKETHEGIO_HISTORY_LIST_FAILD = 'THONGKETHEGIO:HISTORY_FIND_ALL_FAILD'

export const THONGKETHEGIO_UPDATE_FILTER = 'THONGKETHEGIO:UPDATE_FILTER'

export const THONGKETHEGIOCOMLIST_LIST_SUCCESS = 'THONGKETHEGIOCOMLIST:FIND_ALL_SUCCESS'
export const THONGKETHEGIOCOMLIST_LIST_FAILD = 'THONGKETHEGIOCOMLIST:FIND_ALL_FAILD'

export const ThongkethegioAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    updateFilter,
    batTatLoaiDichVu,
    xoaMucDaChon,
    findAllByOrder,
    yeuCauChayLaiCallback,
    handleSuaNhieuMuc,
}

function updateFilter(payload) {
    return { type: THONGKETHEGIO_UPDATE_FILTER, data: payload }
}

function handleSuaNhieuMuc(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { thongkethegio } = getState();            
            // Perform your asynchronous operation (e.g., API call)
            ThongkethegioService.handleSuaNhieuMuc(payload)
            .then(response => {
                dispatch(success(response));
                dispatch(ThongkethegioAction.list());
                resolve(response);
            })
            .catch(error => {
                dispatch(failure(error));
                reject(error);
            });
        });
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function yeuCauChayLaiCallback(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.yeuCauChayLaiCallback(id).then((rs) => {
            dispatch(success(rs.data));
            dispatch(ThongkethegioAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function batTatLoaiDichVu(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ThongkethegioService.batTatLoaiDichVu(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThongkethegioAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function xoaMucDaChon(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ThongkethegioService.xoaMucDaChon(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThongkethegioAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            ThongkethegioService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThongkethegioAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { thongkethegio } = getState()
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...thongkethegio.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_LIST_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_LIST_FAILD, error } }
}

function findAllByOrder(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { thongkethegio } = getState();
        const page = thongkethegio && typeof thongkethegio.filter !== 'undefined' && thongkethegio.filter && typeof thongkethegio.filter.page !== 'undefined' ? thongkethegio.filter.page : 0;
        const limit = thongkethegio && typeof thongkethegio.filter !== 'undefined' && thongkethegio.filter && typeof thongkethegio.filter.limit !== 'undefined' ? thongkethegio.filter.limit : 10;
        ThongkethegioService.findAllByOrder(id, page, limit, thongkethegio.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = thongkethegio.thongkethegiocomlist_items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                console.log({
                    items: uniqueItems,
                    total: rs.data.count
                })
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIOCOMLIST_LIST_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIOCOMLIST_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { thongkethegio } = getState();
        const page = thongkethegio && typeof thongkethegio.filter !== 'undefined' && thongkethegio.filter && typeof thongkethegio.filter.page !== 'undefined' ? thongkethegio.filter.page : 0;
        const limit = thongkethegio && typeof thongkethegio.filter !== 'undefined' && thongkethegio.filter && typeof thongkethegio.filter.limit !== 'undefined' ? thongkethegio.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            ThongkethegioService.findAll(page, limit, thongkethegio.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                        tong_nap: rs.data.tong_nap, 
                        thuc_nhan: rs.data.thuc_nhan, 
                        so_the_dung: rs.data.so_the_dung, 
                        so_the_sai: rs.data.so_the_sai,
                    }));
                } else {
                    const oldItems = thongkethegio.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                        tong_nap: rs.data.tong_nap, 
                        thuc_nhan: rs.data.thuc_nhan, 
                        so_the_dung: rs.data.so_the_dung, 
                        so_the_sai: rs.data.so_the_sai,
                    }));
                }

                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: THONGKETHEGIO_LIST_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: THONGKETHEGIO_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            ThongkethegioService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(ThongkethegioAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: THONGKETHEGIO_SAVE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            ThongkethegioService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(ThongkethegioAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(ThongkethegioAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_CREATE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(ThongkethegioAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_DEL_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_ONE_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(ThongkethegioAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { thongkethegio } = getState()
        dispatch(AppAction.appLoading(true));
        ThongkethegioService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...thongkethegio.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: THONGKETHEGIO_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: THONGKETHEGIO_HISTORY_LIST_FAILD, error } }
}